import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Card from '../../../components/Card/Card';
import getEbayCategoryList from '../../../thunks/general/getEbayCategoryList';
import Button from '../../../components/Button/Button';
import EbayCategoryModal from './EbayCategoryModal';
import Text from '../../../components/Text/Text';
import { getEbayCategoryPath } from '../../../utils/helpers';
import ButtonTypes from '../../../constants/buttonTypes';

const cardBodyClassName = 'px-[30px] pb-[30px]';
const cardContainerClassName = 'flex-none mb-[40px]';
const selectedCategoryTextClassName = 'text-center text-[25px] mb-[20px]';
const selectedCategoryNoteClassName = 'text-center';
const buttonClassName = 'px-[8px] py-[8px] font-normal text-[12px]';

const ArticlesCategory = ({ setFieldValue, selectedCategory }) => {
  const dispatch = useDispatch();
  const [ebayCategoryModal, setEbayCategoryModal] = useState(false);
  const {
    ebayCategoryList, ebayCategoryLoading
  } = useSelector((state) => ({
    ebayCategoryList: state?.getEbayCategoryList?.list,
    ebayCategoryLoading: state?.getEbayCategoryList?.loading,
  }), shallowEqual);

  useEffect(() => {
    if (!ebayCategoryList.length && !ebayCategoryLoading) {
      dispatch(getEbayCategoryList({ categoryId: 6000, levelLimit: 7 }));
    }
  }, []);

  const getSelectedCategory = () => {
    const [{ categoryName = '' } = {}] = ebayCategoryList?.filter(({ categoryId }) => categoryId === selectedCategory);
    return categoryName;
  };

  return (
    <Card
      headerTitle="For category"
      showHeader
      styleBodyContainer={cardBodyClassName}
      styleContainer={cardContainerClassName}
      headerBordered={false}
      required
    >
      {
        selectedCategory && ebayCategoryList.length
          && (
          <>
            <Text bold text={getSelectedCategory()} textStyle={selectedCategoryTextClassName} />
            <Text
              muted
              textStyle={selectedCategoryNoteClassName}
              text={getEbayCategoryPath(ebayCategoryList, selectedCategory)
                ?.map(({ categoryName }) => categoryName)
                ?.join(' > ')}
            />
          </>
          )
      }
      <br />
      <Button
        text={`Select ${selectedCategory ? 'other' : ''} category`}
        onClick={() => setEbayCategoryModal(true)}
        type={ButtonTypes.LIGHT_PRIMARY}
        containerStyle={buttonClassName}

      />
      <EbayCategoryModal
        visible={ebayCategoryModal}
        toggleVisible={() => setEbayCategoryModal(false)}
        setFieldValue={setFieldValue}
        preSelectedCategory={selectedCategory}
      />
    </Card>
  );
};

ArticlesCategory.propTypes = {
  setFieldValue: PropTypes.func,
  selectedCategory: PropTypes.number,
};

ArticlesCategory.defaultProps = {
  setFieldValue: () => {},
  selectedCategory: null,
};

export default ArticlesCategory;
